// extracted by mini-css-extract-plugin
module.exports = {"container":"Indicator_container__1579E","icon":"Indicator_icon__3Etyd","label":"Indicator_label__18FDT","value":"Indicator_value__1kYPs"};